import React, { ReactElement } from "react";
import { Table } from "antd";
import { CatchAllTableRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Ads Id",
    dataIndex: "ads_id",
  },
  {
    title: "Ads Status",
    dataIndex: "ads_status",
  },
  {
    title: "Ads Created At",
    dataIndex: "ads_created_at",
  },
  {
    title: "Publisher",
    dataIndex: "publisher",
  },
  {
    title: "Publisher",
    dataIndex: "publisher_id",
  },
  {
    title: "Cluster",
    dataIndex: "cluster",
  },
  {
    title: "Mp Url",
    dataIndex: "mp_url",
  },
];

type CatchAllTableProps = {
  loading: boolean;
  records: Array<CatchAllTableRecord>;
};

const CatchAllTable = ({ loading, records }: CatchAllTableProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="ads_id"
    pagination={false}
    scroll={{ y: 350, x: 3200 }}
  />
);

export default CatchAllTable;
